export enum FormSteps {
  NICKNAME,
  DISPLAY_NAME,
  SPECIAL_DATES,
  LOCATION,
  DETAILS,
  RESUME,
}
